<template>
  <div class="menu-share">
    <social-sharing
      :url="socialSharingConfig.url"
      :title="socialSharingConfig.title"
      :description="socialSharingConfig.description"
      :quote="socialSharingConfig.quote"
      :hashtags="socialSharingConfig.hashtag"
      :twitter-user="socialSharingConfig.twitterUser"
      inline-template
    >
      <div class="container">
        <network network="facebook">
          <div class="share">
            Facebook<span class="line" v-if="$tvaMq !== 'desktop'">|</span>
          </div>
        </network>
        <network network="linkedin">
          <div class="share">
            Linkedin<span class="line" v-if="$tvaMq !== 'desktop'">|</span>
          </div>
        </network>
        <network network="twitter">
          <div class="share">Twitter</div>
        </network>
      </div>
    </social-sharing>
  </div>
</template>

<script>
export default {
  computed: {
    socialSharingConfig() {
      return this.$ml.get("metadata");
    }
  },
  props: ["config", "content"]
};
</script>
<style lang="scss">
.menu-share {
  .container {
    display: flex;
    flex-direction: column;
  }
  .share {
    cursor: pointer;
    color: $white-50;
    &:hover {
      color: $white;
    }
  }
  .mobile &,
  .tablet & {
    @include ButtonM;
    text-decoration: none;
    color: $white;
    a {
      color: $white;
    }
    .container {
      display: flex;
      flex-direction: row;
    }
    .share {
      color: $white;
      .line {
        padding: 0 10px;
      }
    }
  }
  .desktop & {
    @include ButtonS;
    text-decoration: none;
    color: $white-50;
    a {
      color: $white-50;
    }
  }
}
</style>
